import React, { useState } from 'react';
import { arAgingApi } from '../services/api';
import '../styles/Panel.css';

function ARConsolidationPanel() {
  const [reportingDate, setReportingDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleGenerateConsolidated = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const blob = await arAgingApi.generateConsolidated(reportingDate);

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `AR_Consolidated_${reportingDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setResult({
        success: true,
        message: 'Consolidated AR ageing report generated and downloaded successfully',
        reporting_date: reportingDate
      });
    } catch (err) {
      console.error('Error generating consolidated AR ageing report:', err);
      setError(err.message || 'Failed to generate consolidated AR ageing report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel">
      <h2>AR Ageing - Consolidated Report</h2>
      <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>
        Generate a consolidated AR ageing report combining "Summary by Ageing" data from all 10 TL_RPT entities.
      </p>

      <div className="form-group">
        <label htmlFor="ar-consol-date">Reporting Date:</label>
        <input
          id="ar-consol-date"
          type="date"
          value={reportingDate}
          onChange={(e) => setReportingDate(e.target.value)}
          disabled={loading}
        />
      </div>

      <button
        onClick={handleGenerateConsolidated}
        disabled={loading}
        className="btn btn-primary"
      >
        {loading ? 'Generating...' : 'Generate & Download Consolidated Report'}
      </button>

      {error && (
        <div className="error-message">
          <strong>Error:</strong> {error}
        </div>
      )}

      {result && (
        <div className="success-message">
          <strong>Success:</strong> {result.message}
          <br />
          <small>Reporting Date: {result.reporting_date}</small>
        </div>
      )}

      <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h4>Consolidated Report Details:</h4>
        <ul style={{ marginLeft: '20px', color: '#555' }}>
          <li>Combines "Summary by Ageing" data from 10 entities</li>
          <li>Includes individual tab for each entity</li>
          <li>Consolidated Summary tab with all entities' data and totals</li>
          <li>Shows "Standalone is not ready for this entity and period" for unavailable files</li>
          <li>Entities: Artic GmbH, Blue Medical, Halemed, Integris Medtec, Lamed, Transhealth, Translumina GmbH, TL MD Dubai, TL Therapeutics India, Transvalve</li>
        </ul>
      </div>
    </div>
  );
}

export default ARConsolidationPanel;
